import React from 'react';
import Here1 from '../../../assets/whatsapp-dark.png';
import Here2 from '../../../assets/here2.webp';
import Here3 from '../../../assets/email-dark.png';
import { useTranslation } from 'react-i18next';
import {
  HereDesc1,
  HereDesc2,
  HereDesc3,
  HereHeading1,
  HereHeading2,
  HereHeading3,
} from '../../../Constants';
import useMeta from '../../../hooks/useMeta';

const HereForYou = () => {
  const { t } = useTranslation();

  const DATA = [
    {
      heading: t(HereHeading1),
      desc: t(HereDesc1),
      image: Here1,
      href: 'https://wa.me/+4915156047816',
    },
    // {
    //   heading: t(HereHeading2),
    //   desc: t(HereDesc2),
    //   image: Here2,
    //   href: "https://calendly.com/alessandro-shift-mgmt/riise-with-ale",
    // },
    {
      heading: t(HereHeading3),
      desc: t(HereDesc3),
      image: Here3,
      href: 'hi@weriise.co',
    },
  ];

  const { metaEvent } = useMeta();

  return (
    <div className={`t-flex t-items-center t-justify-center t-gap-4 md:t-gap-8 t-w-full `}>
      {DATA.map((item) => (
        <div
          className="t-w-1/2 t-flex t-flex-col t-items-center t-self-stretch t-gap-0 md:t-gap-4"
          key={'here-item-' + item.heading}
        >
          <a
            href={item.href === 'hi@weriise.co' ? 'mailto:hi@weriise.co' : item.href}
            className="t-font-sans t-font-bold t-text-center !t-leading-5 t-text-quaternary t-underline"
          >
            {item.heading}
          </a>
          <a
            href={item.href === 'hi@weriise.co' ? 'mailto:hi@weriise.co' : item.href}
            target="_blank"
            rel="noreferrer"
            className="t-flex t-items-center t-justify-center"
            onClick={item.href.includes('4915156047816') ? () => metaEvent('Contact') : undefined}
          >
            <img
              src={item.image}
              alt=""
              className={`${item.href === 'hi@weriise.co' ? 't-w-1/3' : 't-w-1/3 md:t-w-1/2'}`}
            />
          </a>
          <p className="t-m-0 t-font-sans t-mt-auto t-text-navy/70 t-text-center">{item.desc}</p>
        </div>
      ))}
    </div>
  );
};

export default HereForYou;
